import React from "react";

export default function InterestedPage() {
  return (
    <div
      className="min-h-screen bg-white text-zinc-900 antialiased flex items-center justify-center px-6 py-16"
      data-testid="interested-page"
    >
      <div className="max-w-[640px] mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter leading-[1.05]">
          You&rsquo;re on the list 🎸
        </h1>
        <p className="mt-6 text-lg md:text-xl text-zinc-600 leading-relaxed">
          Thanks! You&rsquo;ll be first in line, so keep an eye on your inbox
        </p>
        <p className="mt-4 text-lg md:text-xl text-zinc-600 leading-relaxed">
          You can close this page now
        </p>
      </div>
    </div>
  );
}
